import { render, staticRenderFns } from "./IconCommentDots.vue?vue&type=template&id=e208236e&"
import script from "./IconCommentDots.vue?vue&type=script&lang=js&"
export * from "./IconCommentDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports